import { MEGA_BASE_2 } from '@/consts'
import formatBytes from '@/helpers/usage-helpers/format-data'

const toDollars = (cents) => (typeof cents === 'number' ? (cents / 100).toFixed(2) : '')

// Region the BE uses for add-ons that fully cover no region
const ROAMING_OTHERS_REGION = 'Others'

// Map a raw roaming entry (mobileAddon, IsRoaming) from /catalog/v2/entries into
// the add-on shape the local prepay/postpay purchase flow expects. Always one-off.
export default function mapRoamingAddon(entry = {}) {
    const availability = entry.Availabilities?.[0] || {}
    const ch = entry.Characteristics || {}
    const data_mb = parseInt(ch['ocs.PurchaseDataAllowance'], 10) || 0
    const price_cents = availability.RetailCents ?? 0
    const has_discount = entry.origianl_price > price_cents

    return {
        ...entry,
        name: availability.RetailName || entry.Name,
        description: availability.RetailDescription || entry.Description || '',
        cost: toDollars(price_cents),
        origianl_price: has_discount ? toDollars(entry.origianl_price) : '',
        // Fields read by the travel plan card
        price_display: `$${toDollars(price_cents)}`,
        data: data_mb ? formatBytes(data_mb * MEGA_BASE_2, false, 2) : '',
        regions: entry.Regions || [],
        Characteristics: {
            ...ch,
            IsAddon: true,
            AllowAutoRenew: false,
        },
        is_roaming_addon: true,
    }
}

// All BE regions (tabs show even when empty, like travel), then regions only
// found on the add-ons (e.g. "Others") last
export function getRoamingRegions(addons = [], ordered_regions = []) {
    const found = new Set(addons.flatMap(addon => addon.regions || []))

    const unknown = [...found]
        .filter(region => !ordered_regions.includes(region))
        .sort((a, b) => (a == ROAMING_OTHERS_REGION) - (b == ROAMING_OTHERS_REGION))

    return [...ordered_regions, ...unknown]
}
